// theme.js
import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  palette: {
    background: {
      default: "#F6F7F9",
    },
    text: {
      primary: "#64748B",
    },
    primary: {
      main: "#605DFF",
    },
    secondary: {
      main: "#3584FC",
    },
    success: {
      main: "#25B003",
    },
    info: {
      main: "#0dcaf0",
    },
    warning: {
      main: "#ffc107",
    },
    error: {
      main: "#FF4023",
    },
  },
  typography: {
    fontFamily: "Inter, sans-serif", // Use 'Inter' as the default font family
    fontSize: 12.3,
  },
})

export default theme
